import { useContext, useEffect, useState } from 'react';

import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import { Form, Select, Text } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import ModalCustom from '../../../Components/Modal/ModalCustom';
import RemoveModal from '../../../Components/Modal/RemoveModal';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useRole } from '../../../Hooks/Role';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { getApiUrl, getHasHasNot } from '../../../Utils/Helpers';
import { getToken } from '../../../Utils/Token';
import { GymContext } from '../Context/GymContext';
import { confirmationGym } from '../Utils/Helpers';

const Gym = () => {
  const context = useContext(GymContext);
  const navigate = useNavigate();
  const { can, canBoard } = useRole();
  const { get, destroy, put } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [parseParams, setParseParams] = useState({});
  const [cityLoading, setCityLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState({
    id: undefined,
    loading: false,
  });

  useEffect(() => {
    const getData = async () => {
      const params = queryString.parse(search);
      await getGyms();
      setParseParams(params);
      await getTypes();
      await getOwnerTypes();
      await getProvinces();
    };
    getData();
  }, [search]);

  const getTypes = async () => {
    setLoading(true);
    await get(
      '/gym/types',
      (res) => {
        let data = [];
        data.push({
          id: 0,
          title: 'همه',
        });
        data.push(...res.data);
        context.types = data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getOwnerTypes = async () => {
    setLoading(true);
    await get(
      '/gym/gym-types',
      (res) => {
        let data = [];
        data.push({
          id: 0,
          title: 'همه',
        });
        data.push(...res.data);
        context.gymTypes = data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getProvinces = async () => {
    setLoading(true);
    await get(
      '/province',
      (res) => {
        let data = [];
        data.push({
          id: 0,
          name: 'همه',
        });
        data.push(...res.data);
        context.provinces = data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getGyms = async (load = false) => {
    setLoading(true);
    await get(
      `/gym${search}`,
      (res) => {
        context.gyms = res;
        if (load) {
          setLoading(false);
        }
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const removeItem = async (id) => {
    setRemoveLoading(true);
    await destroy(
      `/gym/${id}`,
      (res) => {
        success(`زورخانه "${modalRemoveObject?.name}" با موفقیت حذف شد.`);
        setRemoveLoading(false);
        setModalIsOpen(false);
        getGyms(true);
      },
      (err) => {
        error('حذف به علت خطا انجام نشد.');
        setRemoveLoading(false);
      },
    );
  };

  const getCity = async (provinceId) => {
    setCityLoading(true);
    if (provinceId != 0) {
      await get(
        `/city/${provinceId}`,
        (res) => {
          context.cities = res.data;
          setCityLoading(false);
        },
        (err) => {
          error('دریافت اطلاعات شهر ها با خطا روبرو شد.');
          setCityLoading(false);
        },
      );
    } else {
      context.cities = await [];
      setCityLoading(false);
    }
  };

  const gymFilter = (values, setSubmiting) => {
    let regexPaginate = new RegExp(/page=([0-9]+)/);
    let pageExists = regexPaginate.test(search);
    let paginate = parseParams?.page;

    let filter = pageExists ? `?page=${paginate}` : '';
    Object.entries(values).forEach((item) => {
      if (item[1] != 0 || item[1]?.length > 0) {
        filter +=
          filter.length > 0
            ? `&${item[0]}=${item[1]}`
            : `?${item[0]}=${item[1]}`;
      }
    });
    navigate(`/gym${filter}`);
    setFilterModal(false);
  };

  const onExcelExport = () => {
    let params = search;
    params +=
      params.length > 0 ? `&token=${getToken()}` : `?token=${getToken()}`;
    window.location.href = `${getApiUrl()}/report/gym/excel/${params}`;
  };

  const confirm = async (item, type) => {
    setConfirmLoading({
      id: item?.id,
      loading: true,
    });
    await put(
      `/gym/confirm/${item?.id}`,
      {
        [type]: item?.[type] == 0 ? 1 : item?.[type] == 1 ? 2 : 1,
      },
      (res) => {
        setConfirmLoading({
          id: item?.id,
          loading: false,
        });
        getGyms(true);
        success('عملیات با موفقیت انجام شد');
      },
      (err) => {
        setConfirmLoading({
          id: item?.id,
          loading: false,
        });
        error('خطا در تایید/رد زورخانه');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title='لیست رده زورخانه ها'
          createBtnTitle='ایجاد زورخانه'
          createPath='/gym/create'
          showFilterBtn={true}
          filter={() => setFilterModal(true)}
          showExcelBtn={can('Super Admin') || can('Gym Manager')}
          onExcelExport={onExcelExport}
        />
        <Datatable
          data={context.gyms.data}
          editUrl='/gym/edit'
          meta={context.gyms?.meta}
          search={search}
          disabledEditRemoveIf={(item) =>
            !can('Super Admin') &&
            !can('Gym Manager') &&
            (item?.federation_confirm == 1 || item?.board_confirm == 1)
          }
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          basePagePath={`/gym`}
          columns={[
            'تصویر مدیر',
            'عنوان',
            'استان',
            'شهر',
            'کد پستی',
            'آدرس',
            'نوع مالکیت',
            'سازمان زورخانه',
            'نوع زورخانه',
            'سالن دارای کشتی',
            'مساحت',
            'ظرفیت گود',
            'ظرفیت تماشاچی',
            'تاریخ تاسیس',
            'تلفن زورخانه',
            'نام مالک',
            'نام خانوادگی مالک',
            'موبایل مدیر',
            'تایید فدراسیون',
            (can('Super Admin') || can('Gym Manager')) && 'تایید/رد فدراسیون',
            'تایید هیئت',
            (can('Super Admin') || canBoard() || can('Gym Manager')) &&
              'تایید/رد هیئت',
          ]}
          rows={[
            { name: 'manager_photo.path', type: 'relation', relType: 'image' },
            { name: 'name', type: 'string' },
            { name: 'province.name', type: 'relation', relType: 'string' },
            { name: 'city.name', type: 'relation', relType: 'string' },
            { name: 'zip_code', type: 'string' },
            { name: 'address', type: 'string' },
            {
              name: 'owner_type_name.title',
              type: 'relation',
              relType: 'string',
            },
            {
              name: 'organization_name.title',
              type: 'relation',
              relType: 'string',
            },
            {
              name: 'type_name.title',
              type: 'relation',
              relType: 'string',
            },
            {
              name: 'wrestling_hall_name',
              type: 'string',
            },
            { name: 'area', type: 'string' },
            { name: 'athlete_capacity', type: 'string' },
            { name: 'capacity', type: 'string' },
            { name: 'foundation_date_jalali', type: 'string' },
            { name: 'phone', type: 'string' },
            { name: 'first_name', type: 'string' },
            { name: 'last_name', type: 'string' },
            { name: 'manager_mobile', type: 'string' },
            {
              name: 'federation_confirm',
              type: 'confirm',
              active: {
                0: 'در انتظار بررسی',
                1: 'تایید شده',
                2: 'رد شده',
              },
              badgeClass: {
                0: 'badge-warning',
                1: 'badge-success',
                2: 'badge-danger',
              },
            },
            can('Super Admin') || can('Gym Manager')
              ? {
                  title: 'تایید/رد',
                  type: 'action',
                  action: (item) => confirm(item, 'federation_confirm'),
                  loading: confirmLoading,
                }
              : {},
            {
              name: 'board_confirm',
              type: 'confirm',
              active: {
                0: 'در انتظار بررسی',
                1: 'تایید شده',
                2: 'رد شده',
              },
              badgeClass: {
                0: 'badge-warning',
                1: 'badge-success',
                2: 'badge-danger',
              },
            },
            can('Super Admin') || canBoard() || can('Gym Manager')
              ? {
                  title: 'تایید/رد',
                  type: 'action',
                  action: (item) => confirm(item, 'board_confirm'),
                  loading: confirmLoading,
                }
              : {},
          ]}
        />
      </Master>
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalIsOpen}
        removeItem={removeItem}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف زورخانه "${modalRemoveObject?.name}" مطمئن هستید ؟`}
      />

      <ModalCustom modalIsOpen={filterModal}>
        <div className='d-flex flex-row justify-content-between align-items-center border-bottom pb-2'>
          <span className=''>فیلتر زورخانه ها</span>
          <i
            className='far fa-times text-white f-20 mx-2 c-pointer'
            onClick={() => setFilterModal(false)}
          ></i>
        </div>
        <div className='w-100 my-3'>
          <Form
            initialValues={{
              zip_code: parseParams?.zip_code ?? '',
              province: parseParams?.province ?? 0,
              city: parseParams?.city ?? 0,
              owner_type: parseParams?.owner_type ?? 0,
              wrestling_hall: parseParams?.wrestling_hall ?? 0,
              type: parseParams?.type ?? 0,
              board_confirm: parseParams?.board_confirm ?? 3,
              federation_confirm: parseParams?.federation_confirm ?? 3,
            }}
            defaultActions={false}
            onSubmit={gymFilter}
          >
            <div className='row'>
              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='تایید هیئت'
                  options={confirmationGym(true)}
                  name='board_confirm'
                  optionLabel='label'
                  optionValue='value'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='تایید فدراسیون'
                  options={confirmationGym(true)}
                  name='federation_confirm'
                  optionLabel='label'
                  optionValue='value'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Text
                  name='zip_code'
                  className='w-100'
                  containerClass='w-100'
                  title='کد پستی'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='استان'
                  options={context.provinces}
                  name='province'
                  optionLabel='name'
                  optionValue='id'
                  onChange={(value) => {
                    getCity(value);
                  }}
                />
              </div>
              {!cityLoading && (
                <div className='col-12 col-md-6'>
                  <Select
                    title='شهر'
                    options={context.cities}
                    name='city'
                    optionLabel='name'
                    optionValue='id'
                  />
                </div>
              )}

              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='نوع زورخانه'
                  options={context.types}
                  name='type'
                  optionLabel='title'
                  optionValue='id'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='نوع مالکیت'
                  options={context.gymTypes}
                  name='owner_type'
                  optionLabel='title'
                  optionValue='id'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='سالن کشتی'
                  options={getHasHasNot()}
                  name='wrestling_hall'
                  optionLabel='label'
                  optionValue='value'
                />
              </div>
              <div className='col-12 d-flex flex-row justify-content-center align-items-center'>
                <span
                  className='btn px-5 btn-danger text-white f-12 my-3 mx-2 c-pointer'
                  onClick={() => setFilterModal(false)}
                >
                  انصراف
                </span>
                <button className='btn px-5 btn-info text-white f-12 my-3'>
                  فیلتر
                </button>
              </div>
            </div>
          </Form>
        </div>
      </ModalCustom>
    </>
  );
};

export default Gym;
